export default __webpack_public_path__ + "static/media/Galaxy_06.2ff365e1.png";